import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { scrollbarWidth } from '@xobotyi/scrollbar-width';
import { useEffect } from 'react';
import { useIsDesktop } from './useMediaQuery';
const useScrollLock = condition => {
  const $ = _c(4);
  const isDesktop = useIsDesktop();
  let t0;
  let t1;
  if ($[0] !== condition || $[1] !== isDesktop) {
    t0 = () => {
      const {
        body
      } = document;
      const defaultPadding = isDesktop ? 12 : 0;
      const scrollBarWidthPx = `${(scrollbarWidth() as number) + defaultPadding || defaultPadding}px`;
      if (body) {
        if (condition) {
          body.style.overflow = "hidden";
          body.style.paddingRight = scrollBarWidthPx;
          document.getElementById("nav")?.style.setProperty("padding-right", (scrollbarWidth() as number) + "px");
        } else {
          body.style.overflow = "auto";
          body.style.paddingRight = defaultPadding + "px";
          document.getElementById("nav")?.style.setProperty("padding-right", "0px");
        }
      }
      return () => {
        if (body) {
          body.style.overflow = "auto";
        }
      };
    };
    t1 = [condition, isDesktop];
    $[0] = condition;
    $[1] = isDesktop;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};
export default useScrollLock;